(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {

    const estimatedShippings = document.querySelectorAll('.ot-estimated-shipping');
    estimatedShippings.forEach(es => {

      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1 && node.classList.contains('ot-estimated-shipping-basic-layout')) {
              const esText = node.querySelectorAll('.ot-estimated-shipping-main-text-estimated');
              esText.forEach((txt) =>  txt.innerHTML = txt.innerText.split(' | ')[0]);
            }
          });
        });
      }).observe(es, { childList: true });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sidebar-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const nav = document.getElementById('page-nav-list');
  const headings = document.querySelectorAll('.page-static-section .nav-link-anchor');
  const navLinks = [];

  headings.forEach(anchor => {
    const linkText = anchor.getAttribute('data-link-text') || anchor.textContent;
    if(!navLinks.includes(linkText)) {
      if (!anchor.id) {
        anchor.id = anchor.textContent
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^\w-]/g, '');
      }

      const li = document.createElement('li');
      const a = document.createElement('a');

      a.href = `#${anchor.id}`;
      a.textContent = linkText;

      li.appendChild(a);
      nav.appendChild(li);
      navLinks.push(linkText);
    }    
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Sort options inside a select by data-sort-key (numeric or alphabetical) */
    function sortSelect(select) {
      var currentValue = select.value;
      var opts = Array.from(select.querySelectorAll('option[data-sort-key]'));
      if (!opts.length) return;

      var allNumeric = opts.every(function (o) {
        return o.dataset.sortKey.trim() !== '' && !isNaN(parseFloat(o.dataset.sortKey));
      });

      opts.sort(function (a, b) {
        return allNumeric
          ? parseFloat(a.dataset.sortKey) - parseFloat(b.dataset.sortKey)
          : a.dataset.sortKey.localeCompare(b.dataset.sortKey, undefined, { sensitivity: 'base' });
      });

      /* Remove sorted options, keep placeholder in place */
      opts.forEach(function (o) { o.remove(); });
      var placeholder = select.querySelector('option[value=""]');
      var anchor = placeholder;
      opts.forEach(function (o) {
        if (anchor) { anchor.insertAdjacentElement('afterend', o); } else { select.prepend(o); }
        anchor = o;
      });

      /* Restore value (disabled options can be set programmatically) */
      select.value = currentValue;
    }

    function initSelects() {
      document.querySelectorAll('.variant-option__select[data-sort-numeric]').forEach(function (sel) {
        sortSelect(sel);
        /* BB-UAT11: force blank start — only on initial page load */
        sel.value = '';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSelects);
    } else {
      initSelects();
    }

    /* AA-UAT11: re-sort after morph (variant:update). Preserve morph-applied value — do NOT reset to blank. */
    document.addEventListener('variant:update', function () {
      document.querySelectorAll('variant-picker .variant-option__select[data-sort-numeric]').forEach(sortSelect);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
